import FrameMacSide from './FrameMacSide'

export default FrameMacSide
